import { types } from 'mobx-state-tree';
import { IUser } from '../main/entities';
import { getOmnistore, IOmnistore } from './Omnistore';

export const ProfileStore = types
	.model('Profile', {
	})
	.views(self => ({
		get _omnistore() : IOmnistore {
			return getOmnistore();
		},
	}))
	.views(self => ({
		get ownUserEmail() : string {
			return self._omnistore.authStore.email;
		},
	}))
	.views(self => ({
		get ownUser() : IUser | undefined {
			const o = self._omnistore;
			return o.multirepo.userRepo.allAsList.filter(u => u.email===self.ownUserEmail)[0];
		},
	}))
	.views(self => ({
		get ownUserId() : number {
			const u = self.ownUser;
			return u ? u.id : 0;
		}
	}));
